module.exports = __webpack_public_path__ + "static/media/catalogo Euroboia_PT 2020_13Fev21.d16fc777.pdf";